import { createActionsStructure } from 'services/reduxHelpers'

/* ------------- Action Creators ------------- */

export const { bookingTypes, bookingActions } = createActionsStructure('booking', [
  { name: 'SET_BOOKING_PRICE', async: true },
  { name: 'SUBSCRIBE_BOOKINGS', async: true },
  { name: 'SET_PASSENGER_PLACE', async: true },
  { name: 'UNSUBSCRIBE_BOOKINGS', async: false },
  { name: 'SUBSCRIBE_WEBSITE_BOOKINGS', async: true },
  { name: 'UNSUBSCRIBE_WEBSITE_BOOKINGS', async: false },
  { name: 'GET_RANGE_BOOKINGS', async: true },
  { name: 'GET_CARRIERS_BOOKINGS', async: true },
  { name: 'GET_USER_BOOKINGS', async: true },
  { name: 'SUBSCRIBE_RETURN_BOOKINGS', async: true },
  { name: 'UNSUBSCRIBE_RETURN_BOOKINGS', async: false },
  { name: 'SET_BOOKING', async: true },
  { name: 'DELETE_BOOKING', async: true },
  { name: 'SET_BOOKING_STATUS', async: true },
  { name: 'CLEAR_BOOKINGS', async: false },
  { name: 'CLEAR_RETURN_BOOKINGS', async: false },
  { name: 'SUBSCRIBE_DEPARTURE_BOOKINGS', async: true },
  { name: 'UNSUBSCRIBE_DEPARTURE_BOOKINGS', async: false },
])



// WEBPACK FOOTER //
// ./src/reduxModules/actions/BookingActions.js